import { Component } from '@angular/core';

@Component({
    selector: 'app-track-info-with-violations',
    templateUrl: './track-info-with-violations.component.html',
    styleUrls: ['./track-info-with-violations.component.css'],
    standalone: false
})
export class TrackInfoWithViolationsComponent {
}
